import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  ul: {
    margin: 0,
    padding: 0,
    listStyle: 'none',
  },
  li: {
    '& ul': {
      marginLeft: 20,
      [theme.breakpoints.down(theme.size.sm)]: {
        marginLeft: 10,
      },
    },
  },
  bar: {
    display: 'inline-flex',
    alignItems: 'center',
  },
  button: {
    minWidth: 'auto',
    padding: 3,
    background: 'transparent',
    borderRadius: '50%',
  },
  chevronIcon: {
    color: '#555',
  },
  chevronIconActive: {
    transform: 'rotate(90deg)',
  },
  mainIcon: {
    marginRight: 10,
    color: 'lightgrey',
    fontSize: '1.5rem',
  },
  text: {
    marginLeft: 10,
    fontSize: 14,
    fontFamily: 'NeoSansStd',
    color: theme.custom.darkBlue,
  },
  mock: {
    width: 30,
    height: 30,
    opacity: 0,
    [theme.breakpoints.down(theme.size.sm)]: {
      width: 25,
    },
  },
}));
